import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-market-syudy',
  templateUrl: './market-syudy.component.html',
  styleUrls: ['./market-syudy.component.css']
})
export class MarketSyudyComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }


   
    ngOnInit(): void {
      

  }

  //--------- Page Routings -----//
  MarketStudy(){

    this.router.navigateByUrl(('admin/qatar-market-study')); 
  }
  jebelAliMarketStudy(){
    this.router.navigateByUrl(('admin/jebel-ali-market-study')); 
  } 
  Alqousbm(){
    this.router.navigateByUrl(('admin/Aqousbm-market-study'))
  }
}

